// hide the third step in next button
  const is_preslected_pro = document.querySelector(".clicked_according") || false;
  if (!is_preslected_pro){
    const third_block = document.querySelector(".cust-form-wrapp.third_step");
    const next_btn = third_block?.querySelector("next-btn");
    if(next_btn){ 
      next_btn.classList.add("hidden");
    }
  }

function get_the_step_no(input){
  const parent_step_no = input.closest(".steps_hidden");          
  const step = parent_step_no.querySelector(".qus-numb");      
  const step_no = Number(step?.innerHTML.trim());  
  return step_no;
}

// load more 
function loadmore() {
    var btns = document.querySelectorAll('.load-more-tabs');
    var hiddenItems = document.querySelectorAll('.cricult_tab_data.active .tab-item.hidden-tab');
  
    btns?.forEach(function (btn) {
      if (window.innerWidth > 989 || hiddenItems.length === 0) {
        btn.style.display = 'none';
      }
      btn.addEventListener('click', function() {
        hiddenItems.forEach(function(item) {
          item.classList.remove('hidden-tab');
        }); 
         btn.style.display = 'none';          
      });
      hiddenItems.forEach(function(item) {
        if(item){
          btn.style.display = 'block';
        }else{
           btn.style.display = 'none';
        }
      });     
    });
  }
  
  loadmore();
  // step 6 hide show tab and add tag
  function initTabsAndInputs() {
    document.querySelectorAll("details")?.forEach(function (detailsBlock) {
      const tabButtons = detailsBlock.querySelectorAll(".tab-button");
      
      const inputButtons = detailsBlock.querySelectorAll(".collapsible-card .button_tab_inp");
  
      // Avoid duplicate bindings by checking if already initialized
      if (detailsBlock.dataset.initDone) return;
      detailsBlock.dataset.initDone = "true";
  
      // Tab switching logic
      tabButtons?.forEach(tab => {
        tab.addEventListener("click", function () {      
          tabButtons?.forEach(btn => btn.classList.remove("active"));
          this.classList.add("active");
  
          detailsBlock.querySelectorAll(".tab-section")?.forEach(section => {
            section.classList.remove("visible");
          });
  
          const targetClass = this.getAttribute("data-target");
          detailsBlock.querySelector(`.${targetClass}`)?.classList.add("visible");
        });
      });
  
  
      // Input button logic
      inputButtons?.forEach(btn => {
        btn.addEventListener("change", function () {
          const parent = this.closest(".pro-card-details");
          const sensorData = this.getAttribute("sensor-val-attr");
          const sensorDataName = this.name;
          const sensorhandle = this.getAttribute("data-tabsensor-handle");
          const kabelData = this.getAttribute("kabel-val-attr");
          const kabelDataName = this.name;
          const kabelhandle = this.getAttribute("data-tabkabel-handle");
          const card_parent = this.closest(".grid__item");
          const label_show = card_parent?.querySelector(".selected_product_tag");
          
          if (sensorData) {
            parent.querySelectorAll(".button_tab_inp[sensor-val-attr]")?.forEach(inp => {
              const card_parent = inp.closest(".grid__item");
              const label_show = card_parent.querySelector(".selected_product_tag");
              inp.value = "";
              label_show.innerHTML = "";
            });
  
            const label_text = btn.getAttribute("data-tag-text");
            if (label_text) label_show.innerHTML = label_text;
  
            let input_val = card_parent.querySelector(".quantity__input").value;  
            if(input_val && !card_parent.classList.contains("active")){
              input_val = parseInt(input_val) + 1
              const qty_inp = card_parent.querySelector(".quantity__input"); 
              if(qty_inp)qty_inp.value = input_val;
            }  

            const step_no = get_the_step_no(this); 
             renderSelectedProducts(sensorhandle, sensorDataName, input_val, step_no);

            this.value = sensorData;
            parent.querySelector(".after_sensor")?.classList.add("active");
            parent.querySelector(".befor_sensor")?.classList.remove("active");
  
          } else if (kabelData) {
            parent.querySelectorAll(".button_tab_inp[kabel-val-attr]")?.forEach(inp => {
              const card_parent = inp.closest(".grid__item");
              const label_show = card_parent?.querySelector(".selected_product_tag");
              inp.value = "";
              label_show.innerHTML = "";
            });
  
            const label_text = btn.getAttribute("data-tag-text");
            if (label_text) label_show.innerHTML = label_text;
            let input_val = card_parent.querySelector(".quantity__input").value;  
              if(input_val && !card_parent.classList.contains("active")){
                input_val = parseInt(input_val) + 1
                const qty_inp = card_parent.querySelector(".quantity__input"); 
                if(qty_inp)qty_inp.value = input_val;
              }    

               const step_no = get_the_step_no(this);
              renderSelectedProducts(kabelhandle, kabelDataName, input_val, step_no);
            this.value = kabelData;
            parent.querySelector(".after_cabel")?.classList.add("active");
            parent.querySelector(".befor_cabel")?.classList.remove("active");
          }
        });
      });
    });
  }
  
  document.addEventListener("DOMContentLoaded", initTabsAndInputs);
  // Observe DOM changes for dynamically added elements
  const observer = new MutationObserver(() => {
    initTabsAndInputs();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  
  
  // configure step 1 tab
  const tabs_data = document.querySelectorAll("[data_tab]");
  const contents = document.querySelectorAll("[data_tab_content]");
  
  tabs_data?.forEach(tab => {
    tab.addEventListener("click", function () {
      const target = this.getAttribute("data-tab");
      // Remove active + add hidden from all tabs_data & contents
      tabs_data.forEach(t => t.classList.remove("active"));
      contents?.forEach(c => {
        c.classList.remove("active");
        c.classList.add("hidden");
      });
  
      // Activate clicked tab
      this.classList.add("active");
  
      // Activate target content
      const targetContent = document.getElementById(target);
      if (targetContent) {
        targetContent.classList.add("active");
        targetContent.classList.remove("hidden");
      }
    });
  });
  
  function sortBlogPosts(option) {
    const postsContainers = document.querySelectorAll(".product-card-sorting");
  
    postsContainers?.forEach((postsContainer) => {
      const postsArray = Array.from(postsContainer.querySelectorAll(".cust_sort_blog"));
  
      switch (option) {
        case "title-ascending":
          postsArray.sort((a, b) => {
            const titleA = a.querySelector(".product-card-title").textContent.trim();
            const titleB = b.querySelector(".product-card-title").textContent.trim();
            return titleA.localeCompare(titleB);
          });
          break;
  
        case "title-descending":
          postsArray.sort((a, b) => {
            const titleA = a.querySelector(".product-card-title").textContent.trim();
            const titleB = b.querySelector(".product-card-title").textContent.trim();
            return titleB.localeCompare(titleA);
          });
          break;
  
        case "price-ascending":
          postsArray.sort((a, b) => {
            const priceA = parseFloat(
              a.querySelector(".price__container")?.textContent.replace(/[^0-9.]/g, "") || 0
            );
            const priceB = parseFloat(
              b.querySelector(".price__container")?.textContent.replace(/[^0-9.]/g, "") || 0
            );
            return priceA - priceB;
          });
          break;
  
        case "price-descending":
          postsArray.sort((a, b) => {
            const priceA = parseFloat(
              a.querySelector(".price__container")?.textContent.replace(/[^0-9.]/g, "") || 0
            );
            const priceB = parseFloat(
              b.querySelector(".price__container")?.textContent.replace(/[^0-9.]/g, "") || 0
            );
            return priceB - priceA;
          });
          break;
  
          case "date-newest":
            postsArray.sort((a, b) => {
              const dateA = new Date(a.querySelector(".created_date_product")?.textContent.trim() || 0);
              const dateB = new Date(b.querySelector(".created_date_product")?.textContent.trim() || 0);
              return dateB - dateA;
            });
            break;
    
          case "date-oldest":
            postsArray.sort((a, b) => {
              const dateA = new Date(a.querySelector(".created_date_product")?.textContent.trim() || 0);
              const dateB = new Date(b.querySelector(".created_date_product")?.textContent.trim() || 0);
              return dateA - dateB;
            });
            break;            

        default:
          return;
      }
  
      // Clear and re-append sorted posts
      postsContainer.innerHTML = "";
      postsArray.forEach((post) => postsContainer.appendChild(post));
    });
  }
  
  // Dropdown listeners
  document.getElementById("sorting-dropdown")?.addEventListener("change", function () {
    sortBlogPosts(this.value);
  });
  
  document.getElementById("credit-sorting-dropdown")?.addEventListener("change", function () {
    sortBlogPosts(this.value);
  });

  
  function is_selected_any_product(input) {    
    let current = input?.parentElement;  
    while (current) {
      if (current.classList.contains("cust-form-wrapp")) {
        current.classList.add("is_selected");
      }
      current = current.parentElement;
    }
  }
    
  function isalready_selected_any_product(input){
    let current = input?.parentElement;  
    while (current) {
      if (current.classList.contains("cust-form-wrapp")) {
        current.classList.remove("is_selected");        
      }
      current = current.parentElement;
    }
  }
  

      
    
  function PreProductATC(radio){
    const gehause_handle = radio.getAttribute("static-product");
    const product_div = radio.querySelector(".main_product_radio");
    var is_scm = null;  
    
    
    console.log("gehause_handle",gehause_handle);

    if(gehause_handle){
      SpinnerAdd();
      selecetd_product_show(gehause_handle, product_div, is_scm);
      // canvasSet();
       SpinnerRemove();
      //  localStorage.setItem("show_image_main", JSON.stringify(gehause_handle));       
    }
  }
    

  // step one in pre selected product in step 2
  const accordion_second_product = document.querySelectorAll(".second-step .accordion-image-title-content-item .accordion_input");
  accordion_second_product?.forEach(input => {
    const click_btn = input.closest(".accordion__content");
    const main_form = input.closest("configure-form").querySelector(".selected_multi_acc.sixth-step");
    click_btn.classList.remove("clicked_according")
    input.addEventListener("change", async () => {    
      const handle = input.getAttribute("pre_product_gehuse") || input.getAttribute("pre-selecetd-handle");
      
      const main = input.closest("configure-form");
      const matchedCard = [...main.querySelectorAll("[single_accordion_select] .grid__item .card_product_custom")].find(card => card.getAttribute("data-product-handle") === handle) || null;
      // const radio =  matchedCard?.querySelector(".variant-radio")?.click();
      
      if(matchedCard){  
        const radio =  matchedCard?.querySelector(".variant-radio");        
          // radio.click();
        Stapthreeredio(radio); 
      }
    });
  });
  
const accordion_second_product_two = document.querySelectorAll(".second-step .accordion summary");
console.log("accordion_second_product_two",accordion_second_product_two);
  accordion_second_product_two?.forEach(input => {
    const click_btn = input.closest("details");
    click_btn.classList.remove("clicked_according");    
    const main_input = input.closest("details").querySelector(".step_2_result_title");

    input.addEventListener("click", async () => {    
      const products_model = main_input.getAttribute("pre-selected-product-model");    
      const main = input.closest("configure-form");                          
      const input_val = 1;
      const main_name = main_input.name;  
      
      click_btn.classList.add("clicked_according");

      const normalizeHandle = (str) =>str?.toString().trim().toLowerCase().replace(/®/g, '').replace(/\s+/g, '');

      const parsedProducts = products_model.split(",").map(item => {
        const [handle, quantity] = item.split("^_^");
        return {
          handle: normalizeHandle(handle),
          quantity: quantity || 1
        };
      });

      const elements = Array.from(document.querySelectorAll(".fourth_step metawise-variant-selector .main-tab-products-content .card_product_custom[data-product-handle]"));
      
      parsedProducts.forEach(product => {
        const matchEl = elements.find(el => {
          const rawHandle = el.getAttribute("data-product-handle");
          return normalizeHandle(rawHandle) === product.handle;
        });          
        if (matchEl) {
          const btn = matchEl.closest(".grid__item")?.querySelector(".cust_btn_select");
          const main_preselected_product = matchEl.closest(".grid__item") || null;
          if(main_preselected_product) main_preselected_product.classList.add('hidden')
          // if (btn) btn.click();
          if (btn) handleSelection_all(btn,true,false,false); 
        }
      });

    // const clickedInput = input.getAttribute("pre_product_zubehor");
    // if (!clickedInput) return;

    // const normalizeHandle = (str) =>str?.toString().trim().toLowerCase().replace(/®/g, '').replace(/\s+/g, '');
    // const parsedProducts = clickedInput.split(",").map(item => {
    //   const [handle, quantity] = item.split("^_^");
    //   return {
    //     handle: normalizeHandle(handle),
    //     quantity: quantity || 1
    //   };
    // });

    // console.log("parsedProducts =", parsedProducts);
    // const variantInputs = document.querySelectorAll(".eighth_step .tab-panel .tab_product_inp[data-tab-product-handle]");

    // variantInputs.forEach(el => {
    //   const rawHandle = el.getAttribute("data-tab-product-handle");
    //   const productHandle = normalizeHandle(rawHandle);
    //   const matched = parsedProducts.find(p => p.handle === productHandle);
    //   console.log("Checking:", productHandle, "Matched:", matched);
    //   if (matched) {
    //     const btn_input = el.closest(".grid__item")?.querySelector(".cust_btn_select");
    //     if (btn_input) {
    //       btn_input.click();   // or btn_input.checked = true;
    //     }
    //   }
    // });

                  // jk remaning the image add in sticky bar
                  // Store the first handle in a variable if it's the first time
                  // if (!window.firstHandleStored) {     
                  //   const main_progress_bar = matchedCard.querySelector(".card__media img");
                  //   const progress_bar = document.querySelectorAll(".progressbar_image");
                  //     progress_bar.forEach(function(bar){
                  //       const image_bar = bar.querySelector("img");          
                  //       if(image_bar && main_progress_bar){
                  //         image_bar.src = main_progress_bar.src;
                  //       }    
                  //     });    
                  //   window.firstHandleStored = card_handle; // Store the handle globally    
                  // }
    
      //   document.querySelectorAll('.single_accordion_select .selected_product_tag').forEach(tag => tag.innerHTML = "");
      //   is_selected_any_product(input);

      // localStorage.setItem("show_image_main", JSON.stringify(handle));      
    });
  });



  // multiple card selecte on step 3 
  const checkbox_multi = document.querySelectorAll('.checkbox-with-producard .variant-checkbox');  
  checkbox_multi?.forEach(function (checks) {    
    checks.addEventListener('change', async function () {
      
      const card = checks.closest('.product-card[data-variant-id]');    
      const product_tag = card.querySelector('.selected_product_tag');
      const product_tag_label = product_tag.getAttribute("tag-attr") || "Ausgewählt"; 
      const variantId = card.getAttribute('data-variant-id');
      const card_handle = card.getAttribute("data-handle");
      const card_gid = checks.getAttribute("data-product-gid");
      
      const data_wrapp = document.querySelector(".show_selecetd_collaps_product");
      
      SpinnerAdd();
      
      // Store the first handle in a variable if it's the first time
      if (!window.firstHandleStored) {     
        const main_progress_bar = card.querySelector(".card__media img");
        const progress_bar = document.querySelectorAll(".progressbar_image");
          progress_bar.forEach(function(bar){
            const image_bar = bar.querySelector("img");          
            if(image_bar){
              image_bar.src = main_progress_bar.src;
            }    
          });
  
        window.firstHandleStored = card_handle; // Store the handle globally    
      }
  
      if (!window.firstIdStored) {        
        window.firstIdStored = card_gid; // Store the handle globally    
      }

      if (data_wrapp) {
        const data_wrapp_info = await selectedAccordionProductShow(card_handle);
        if (data_wrapp_info) {
          let oldEl = data_wrapp.querySelector(`.multi_collaps_product[data-handle="${card_handle}"]`);        
          if (oldEl) {
            oldEl.replaceWith(data_wrapp_info); 
          } else {
            data_wrapp.appendChild(data_wrapp_info); 
          }
        }
  
        const selected_card = this.closest('.grid__item');
        const handle_tab = this.getAttribute("data-var-handle");        
        let input_val = selected_card.querySelector(".quantity__input")?.value || 1;  
        if(input_val){
          input_val = parseInt(input_val) + 1;
          const qty_inp = selected_card.querySelector(".quantity__input"); 
          if(qty_inp)qty_inp.value = input_val;
        }   

        const step_no = get_the_step_no(this);

        if(handle_tab){
          renderSelectedProducts(handle_tab, checks.name, input_val, step_no);
        }
        SpinnerRemove();
      }
  

      // Reset previous tags and classes
      product_tag.innerHTML = product_tag_label;
    });
  });
  
  // tag click in card hide show step 4 
  const tagLinks = document.querySelectorAll('.tag-wise-tab-wrap .cust-tag-link');
  const productCards = document.querySelectorAll('.tag-wise-tab-wrap .product-card');
  tagLinks?.forEach(link => {
    link.addEventListener('click', function () {
       tagLinks.forEach(l => l.classList.remove('active'));
      const selectedTag = this.getAttribute('data-tag');
      const active_tag = this.classList.add('active');
      const all_tag = this.getAttribute('all-data-tag');
      productCards.forEach(card => {
        const cardTag = card.querySelector('.custom_label_data');
        const tag_attr = cardTag?.getAttribute('data-custom-label');
       
        if (tag_attr === selectedTag) {
          card.style.display = 'block';
        }else if(all_tag){
           card.style.display = 'block';
        }else {      
          card.style.display = 'none';
        }     
      });
    });
  });
  
  function renderSelectedProducts(allMetaValues, names, input_val,step_no) {
    
    const quantity = Number(input_val) || 1;
    // Normalize to arrays
    if (!Array.isArray(allMetaValues)) allMetaValues = [allMetaValues];
    if (!Array.isArray(names)) names = [names];
  
    // Remove duplicate handles
    const uniqueHandles = [...new Set(allMetaValues)];
    let stored = JSON.parse(localStorage.getItem("selectedProducts") || "[]");  

    for (let i = 0; i < uniqueHandles.length; i++) {      
      const handle = uniqueHandles[i];
      const name = names[i] || "";
      const existingIndex = stored.findIndex(item => item.name === name);
      
      if (existingIndex !== -1) {
        // stored[existingIndex].handle = handle;
        stored[existingIndex] = {
          ...stored[existingIndex],
          handle,
          name,
          quantity,
          step_no
        };
        stored = stored.filter(item => item.step_no !== 4);
      } else {
        stored.push({ handle, name, quantity, step_no });
        
      }
    }
  
    // Step 3: Save updated stored data back to localStorage
    localStorage.setItem("selectedProducts", JSON.stringify(stored));
    localStorage.setItem("resultProduct", JSON.stringify(stored));
  }
  
  function multiProductsAccSelected(allMetaValues, names) {
    // Normalize to arrays
    if (!Array.isArray(allMetaValues)) allMetaValues = [allMetaValues];
    if (!Array.isArray(names)) names = [names];
  
    // Remove duplicate handles
    const uniqueHandles = [...new Set(allMetaValues)];
    let stored = JSON.parse(localStorage.getItem("multiProductsAccSelected") || "[]");  
    let stored_slot = JSON.parse(localStorage.getItem("slotproduct") || "[]");

    for (let i = 0; i < uniqueHandles.length; i++) {
      const handle = uniqueHandles[i];
      const name = names[i] || "";
      const existingIndex = stored.findIndex(item => item.name === name);

      if (existingIndex !== -1) {
        stored[existingIndex].handle = handle;
      } else {
        stored.push({ handle, name, quantity: 1 });
      }
    }
  
    // Step 3: Save updated stored data back to localStorage
    localStorage.setItem("multiProductsAccSelected", JSON.stringify(stored));
  }
  

  
   
  
  const result_step = document.querySelector(".show_selected_content");
  if (result_step) result_step.style.display = "none";
  
  const form_attr = document.querySelector(".footer_icon_with_text");
  const is_form = document.querySelector("configure-form");
  if(is_form && form_attr != "false"){  
        form_attr.style.display = "none";
  }


  function selected_product_tag() {
    const data = document.querySelector('.selected_product_data.active');
    if (!data) return;
  
    const productCards = data.querySelectorAll('.product-card[data-variant-id]');
    const product_tag_label = data.dataset.selectedLabel || "Ausgewählt"; 
    const first_meta = data.querySelector(".first-meta-val")?.checked;
    const second_meta = data.querySelector(".seond-meta-val")?.checked;
    const third_meta = data.querySelector(".third-meta-val")?.checked;
    const first_meta_name = data.querySelector(".first-meta-val")?.name;
    const second_meta_name = data.querySelector(".seond-meta-val")?.name;
    const third_meta_name = data.querySelector(".third-meta-val")?.name;
    
      // Define all meta values dynamically in an array
      const metas = [
        { value: data.querySelector('.first-slot[data-first-meta]')?.dataset.firstMeta, checked: first_meta, class: 'firstMeta' },
        { value: data.querySelector('.second-solt[data-second-meta]')?.dataset.secondMeta, checked: second_meta, class: 'secondMeta' },
        { value: data.querySelector('.third-slot-meta[data-third-meta]')?.dataset.thirdMeta, checked: third_meta, class: 'thirdMeta' },
      ];  
  
    // result page content step 3
      let allMetaValues = Array.from(
        data.querySelectorAll('[data-first-meta-handle], [data-second-meta-handle], [data-third-meta-handle]')
      ).map(el => Object.values(el.dataset)[0])
        .filter(value => value && value.trim() !== "");
      let name_input = [first_meta_name, second_meta_name, third_meta_name]
        .filter(value => value && value.trim() !== "");
        const input_val = 1;

        renderSelectedProducts(allMetaValues, name_input, input_val);
    //end result
  
    productCards?.forEach(card => {
      const product_tag = card.querySelector('.selected_product_tag');
      const variantId = card.getAttribute('data-variant-id');
  
      // Reset previous tags and classes
      card.classList.remove('firstMeta', 'secondMeta', 'thirdMeta');
      product_tag.innerHTML = "";
      let tags = [];
  
      metas.forEach((meta, index) => {
        // 
        if (variantId === meta.value && meta.checked) {
          card.classList.add(meta.class); 
         tags.push(`<span>${index + 1}</span> ${product_tag_label}`);
        }    
      });
  
      product_tag.innerHTML = tags.join(", ");
    });
  }
  
  // step 7  radio-with-tab
  const radios_tab = document.querySelectorAll('.main-radio');
  const seenTexts = new Set();
    radios_tab?.forEach((radio) => {
      const text = radio.getAttribute('data-radio-text');
      if (seenTexts.has(text)) {
        radio.style.display = 'none';
      } else {
        seenTexts.add(text);
      }
    });
   
  const tab_radio = document.querySelector(".data-tab-radio");
  tab_radio?.addEventListener('change', function () {
    const tab_content = document.querySelectorAll("[data-main-radio]");
    let matchedOnce = false;
  
    tab_content?.forEach((tab) => {
      const text_content = tab.getAttribute('data-main-radio');
      tab.style.display = "none"; 
  
      if (!matchedOnce && tab_radio.checked && text_content === "Nodelocked") {
        tab.style.display = "block";
        matchedOnce = true;
      } else if (!matchedOnce && !tab_radio.checked && text_content === "Floating") {
        tab.style.display = "block";
        matchedOnce = true;
      }
    });
  });
  
  const tab_button = document.querySelectorAll(".tab-title-button");
    tab_button?.forEach(link => {
      link.addEventListener('click', function () {
        const btn_attr = this.getAttribute("tab-data-button");
        const radio_val = this.getAttribute("data-btn-radio");
        
         tab_button.forEach(l => l.classList.remove('active'));
        const active_tag = this.classList.add('active');
        
        document.querySelectorAll(".tab-wrapp[tab-data]").forEach((content) => {
          const btn_content = content.getAttribute("tab-data");
          const tab_radio = document.querySelector(".data-tab-radio");
          content.style.display = "none";
          if(btn_attr == btn_content && tab_radio.checked && radio_val == "Nodelocked"){
            content.style.display = "block";          
          }else if( tab_radio.checked && radio_val == "Nodelocked" ){        
            content.style.display = "none";
          }
          if(btn_attr == btn_content && !tab_radio.checked && radio_val == "Floating"){          
            content.style.display = "block";
          }else if( !tab_radio.checked && radio_val == "Floating" ){          
            content.style.display = "none";
          }
        });
      });
    });
  
  // step 8  tab-with-product
  document.querySelectorAll('[tab-button]').forEach(function(tabBtn) {
    tabBtn?.addEventListener('click', function() {
      var target = this.getAttribute('data-target');
  
      // Remove active + hide all panels
      document.querySelectorAll('[tab-button]').forEach(el => el.classList.remove('active'));
      document.querySelectorAll('[tab-panel]').forEach(el => {
        el.classList.remove('active');
        el.classList.add('hidden');
      });
  
      // Activate clicked tab + corresponding panel
      this.classList.add('active');
      var targetPanel = document.getElementById(target);
      if (targetPanel) {
        targetPanel.classList.add('active');
        targetPanel.classList.remove('hidden');
      }
    });
  });
  
  // extra step 3 tab hide show
  function tab_active(){
    const tab_1 = document.querySelector(".cricult_tab_1");
    const tab_1_content = document.querySelector(".cricult_tab_1_data");
    const tab_2 = document.querySelector(".cricult_tab_2");
    const tab_2_content = document.querySelector(".cricult_tab_2_data");
  
    tab_1?.addEventListener('click',function (e) {  
        tab_1_content?.classList.add("active");
        tab_2_content?.classList.remove("active");
        tab_1?.classList.add("active");
        tab_2?.classList.remove("active");
      loadmore();
    });
  
    tab_2?.addEventListener('click',function (e) {  
        tab_2_content?.classList.add("active");
        tab_1_content?.classList.remove("active"); 
        tab_2?.classList.add("active");
        tab_1?.classList.remove("active");
      loadmore();
    });
  }
  
  // credit radio accordian show
  const radios_credit = document.querySelectorAll('.credit_radio');
  const accordionBlocks = document.querySelectorAll('.collapse-accordian-block');
  
    radios_credit?.forEach(radio => {
      radio.addEventListener('change', function () {
        if (radio.dataset.tabwiseShow == true ){
          const selectedId = this.id; 
          accordionBlocks?.forEach(block => {
            if (block.dataset.inputVal === selectedId) {
              block.style.display = 'block';
            } else {
              block.style.display = 'none';
            }
          });
        }      
      });
    });
  
    // Trigger change event on load to show correct default
    const checkedRadio = document.querySelector('.credit_radio:checked');
    if (checkedRadio) {
      checkedRadio.dispatchEvent(new Event('change'));
    }
  
  // const plus_click =  document.querySelectorAll(".eighth_step .plus_qty_product");
  // plus_click?.forEach(plus => {
  //   plus?.addEventListener('click', function () {
  //     // const all_cards = document.querySelectorAll('.grid__item');
  //     const all_cards = this.closest('.eighth_step')?.querySelectorAll('.grid__item'); 
  //     const selected_card = this.closest('.grid__item');
  //     const input_btn = plus?.closest("quantity-input");    
  //     const input_val = input_btn?.querySelector(".quantity__input").value;
  //     const parent = this.closest(".grid__item").querySelector(".tab_product_inp");
  
  //     if(input_val >= 0){
  //       selected_card.classList.add("active");     
  //       const handle_tab = parent.getAttribute("data-tab-product-handle");        
  //       const step_no = get_the_step_no(this);

  //       renderSelectedProducts(handle_tab, parent.name, input_val, step_no);
  //       // is_selected_any_product(parent,all_cards,selected_card);            
  //     }else{        
  //       selected_card.classList.remove("active");
  //       // is_selected_any_product(parent,all_cards,selected_card);       
  //     }    
  //   });
  // });    

  // step 3 
  async function getProductInfo(handle) {
    try {
      const response = await fetch(`/products/${handle}?view=tab`);
      const productHTML = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(productHTML, 'text/html');
  
      const imageInfoEl = doc.querySelector('.image-info');
      const mainCricultTabEl = doc.querySelector('.main-cricult_tab');
      const barImageEl = doc.querySelector('.closest_product_img_wrapp');
  
      return {
        imageInfo: imageInfoEl ? imageInfoEl.outerHTML : '',
        mainCricultTab: mainCricultTabEl ? mainCricultTabEl.outerHTML : '',
        barImage: barImageEl ? barImageEl.innerHTML : ''
      };
  
    } catch (error) {
      console.error('Error fetching product info:', error);
      return null;
    }
  }
  
  // step 3 selected product show
  async function selectedProduct(handle) {    
    try {
      const response = await fetch(`/products/${handle}?view=selected_product`);
      const productHTML = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(productHTML, 'text/html');
      const mainDivEl = doc.querySelector('.selected_product_flex');
  
      if(mainDivEl){
        return mainDivEl;
      }else{
        return null;
      }
      return 
        // mainDiv: mainDivEl ? mainDivEl.outerHTML : '',     
  
    } catch (error) {
      console.error('Error fetching product info:', error);
      return null;
    }
  }
  
  
  async function selectedMultiProductShow(handle) {
    try {
      const response = await fetch(`/products/${handle}?view=multi_content`);
      const productHTML = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(productHTML, 'text/html');
      const mainDivEl = doc.querySelector('.multi_product_info');
      if(mainDivEl){
        return mainDivEl;
      }else{
        return null;
      }
      return   
  
    } catch (error) {
      console.error('Error fetching product info:', error);
      return null;
    }
  }

  async function cardProduct(handle) {
    try {
      const response = await fetch(`/products/${handle}?view=card_product`);
      
      const productHTML = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(productHTML, 'text/html');
      const mainDivEl = doc.querySelector('.card_product_custom');
      if(mainDivEl){
        return mainDivEl;
      }else{
        return null;
      }
      return   
  
    } catch (error) {
      console.error('Error fetching product info:', error);
      return null;
    }
  }


  async function pagination_collection(handle) {    
    try {
      const response = await fetch(`/collections/${handle}?view=pagination_collection`);
      const productHTML = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(productHTML, 'text/html');
      const mainDivEl = doc.querySelector('.pagination_collection_filter');      
      if(mainDivEl){
        return mainDivEl;
      }else{
        return null;
      }
      return   
  
    } catch (error) {
      console.error('Error fetching product info:', error);
      return null;
    }
  }

  async function multi_acc_card_product(handle,blockId,index) {    
    try {
      const response = await fetch(`/products/${handle}?view=multi_acc_card_product&block_id=${blockId}`);
      const productHTML = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(productHTML, 'text/html');
      const mainDivEl = doc.querySelector('.card_product_custom');   
      if(mainDivEl){
        const time_stemp = Date.now();       
       let input = mainDivEl.querySelector(".variant-checkbox.cust_btn_select") || null; 
       let label = input?.nextElementSibling;    
      //  
        // input = `contact[__product__meta_wise_filter_pro-${blockId}-${time_stemp}-${index}]`
        if(input){
           const originalId = input.id || "meta_input";
            const newId = `${originalId}-${blockId}-${time_stemp}-${index}`;

            input.id = newId;

            input.setAttribute(
              "name",
              `contact[__product__meta_wise_filter_pro-${blockId}-${time_stemp}-${index}]`
            );
              if (label) {
                  label.setAttribute("for", newId);
                }

          }
        // 
        return mainDivEl;
      }else{
        return null;
      }
      return   
  
    } catch (error) {
      console.error('Error fetching product info:', error);
      return null;
    }
  }
  

  async function metaSelectedProduct(handle,collections_infor) {
    try {
      const response = await fetch(`/products/${handle}?view=metawise_selecetd`);
      const productHTML = await response.text();      
      const parser = new DOMParser();
      const doc = parser.parseFromString(productHTML, 'text/html');
      const mainDivEl = doc.querySelector('.selected_product_flex_meta');  
      if(collections_infor){
         const mainDivEl_coll = doc.querySelector('[data-js-append]'); 
         collections_infor.innerHTML="";
         if(mainDivEl_coll) collections_infor.appendChild(mainDivEl_coll);
      }
      if(mainDivEl){
        return mainDivEl;
      }else{
        return null;
      }
      return 
        // mainDiv: mainDivEl ? mainDivEl.outerHTML : '',     
  
    } catch (error) {
      console.error('Error fetching product info:', error);
      return null;
    }
  }
  
  // step 3 accordian product show in step 6
  async function selectedAccordionProductShow(handle) {
    try {
      const response = await fetch(`/products/${handle}?view=selected_accordian_show`);
      const productHTML = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(productHTML, 'text/html');
      const mainDivEl = doc.querySelector('.multi_collaps_product');
      if (mainDivEl) {
          mainDivEl.setAttribute("data-handle", handle);
        return mainDivEl;
      }
      if(mainDivEl){
        return mainDivEl;
      }else{
        return null;
      }
      return   
  
    } catch (error) {
      console.error('Error fetching product info:', error);
      return null;
    }
  }
  
  async function selectedAccordionProductShowMulti(handle,slot_title) {
    try {
      const response = await fetch(`/products/${handle}?view=selected_rs_multi_acc`);
      const productHTML = await response.text();      
      const parser = new DOMParser();
      const doc = parser.parseFromString(productHTML, 'text/html');
      const mainDivEl = doc.querySelector('metawise-variant-selector');  
      if(mainDivEl){
        console.log("mainDivEl",mainDivEl);
        let product_handing = mainDivEl.querySelector(".slot_title");
        product_handing.innerHTML=slot_title;
        return mainDivEl;
      }else{
        return null;
      }
        // mainDiv: mainDivEl ? mainDivEl.outerHTML : '',     
    } catch (error) {
      console.error('Error fetching product info:', error);
      return null;
    }
  }

  // store result page in step2 
  const accordian_confi = document.querySelectorAll(".second-step .accordion-image-title-content-item .accordion_input");
  accordian_confi?.forEach(input => {
    input?.addEventListener("change", function (inp) {   
      const wrapper = input.closest(".accordion-image-title-content-item-inner");
      const acc_image = wrapper?.querySelector(".acco-img")?.src;
      const acc_title = wrapper?.querySelector(".build-title")?.innerHTML;
      const acc_content = wrapper?.querySelector(".accordion-image-content")?.innerHTML;  
      let acc_stored = [];
      if(acc_image || acc_title || acc_content){
        acc_stored.push({ acc_image: acc_image,acc_title: acc_title,acc_content: acc_content});
        localStorage.setItem("accordian_info", JSON.stringify(acc_stored));     
      }    
    });
  });
  
  // store result step 5
  const accordian_fifth = document.querySelectorAll(".fifth_step .accordion-image-title-content-item .accordion_input.content_show_local");
  // localStorage.removeItem('fifth_accordian_info');
  accordian_fifth?.forEach(input => {
    input?.addEventListener("change", function (inp) {
      const wrapper = input.closest(".accordion-image-title-content-item-inner");
      const acc_title = wrapper?.querySelector(".build-title")?.innerHTML;
      const acc_content = wrapper?.querySelector(".accordion-image-content")?.innerHTML;  
      let acc_stored = [];
      if( acc_title || acc_content){        

        const index = acc_stored.findIndex(item => item.acc_title === acc_title);
        if (input.checked) {        
          if (index === -1) acc_stored.push({acc_title: acc_title,acc_content: acc_content});        
        } else {      
          if (index !== -1) acc_stored.splice(index, 1);        
        }

        localStorage.setItem("fifth_accordian_info", JSON.stringify(acc_stored));      
      }    
    });
  });
  
  
  // store result step 7 
  const tabContentInputs = document.querySelectorAll(".seventh_step .software-functionalities input[name='contact[tab-contemt-box]']");
  const acc_show_container = document.querySelector(".show_seventhstep.muliselect_show");
  if(acc_show_container){acc_show_container.innerHTML = ""; }
  tabContentInputs?.forEach(input => {
    input?.addEventListener("change", function () {
      const wrapper = input.closest(".tab-content-box");
      const acc_title = input.value;
      const acc_content = wrapper?.querySelector(".content")?.innerHTML;
      if (!acc_title && !acc_content) return;
  
      let storedData = JSON.parse(localStorage.getItem("seventh_tab_info") || "[]");
  
      if (input.checked) {
        // Add only if not already in storage
        if (!storedData.some(item => item.acc_content === acc_content)) {
          storedData.push({ acc_title, acc_content });
      } else {
        // Remove unchecked item from storage
        storedData = storedData.filter(item => item.acc_title !== acc_title);
        }
      }
      localStorage.setItem("seventh_tab_info", JSON.stringify(storedData));
    });
  });
  
  // ====== Utility function to update storage and DOM to result page ======
    function saveAndDisplay(container, storageKey, title, values) {
      const data = JSON.parse(localStorage.getItem(storageKey) || "[]");
      const idx = data.findIndex(item => item.title === title);
      if (idx > -1) {
        data[idx].values = values;
      } else {
        data.push({ title, values });
      }
      localStorage.setItem(storageKey, JSON.stringify(data));
  
      if (values && (Array.isArray(values) || typeof values === "object")) {
        valueText = Object.entries(values).map(([k, v]) => `${k} = ${v}`).join(", ");
      } else {
        valueText = values;
      }
  
      let li = container?.querySelector(`li[data-title="${title}"]`);
      if (!li) {
        li = document.createElement("li");
        li.setAttribute("data-title", title);
        container?.appendChild(li);
      }
    
      li.innerHTML = `<p>${title}</p>
        <p>${valueText}</p>`;
    }
    
    // ====== SINGLE RANGE ======
    const singleContainer = document.querySelector(".hardware_pdp_single_range");
    if (singleContainer) singleContainer.innerHTML = "";
    // localStorage.removeItem("single_range_info");
  
    document.querySelectorAll(".single_range").forEach(group => {
      const titleEl = group.querySelector(".quetion_text");
      if (!titleEl) return;
      const title = titleEl.textContent.trim();
  
      const input = group.querySelector('input[data-single-range-qty]');
      if (!input) return;
  
      const update = () => saveAndDisplay(singleContainer, "single_range_info", title, input.value );
      if(singleContainer){singleContainer.style.display = 'block';}
      input.addEventListener("input", update);
      update();
    });
  
    // ====== TWO RANGE ======
    const twoContainer = document.querySelector(".hardware_pdp_two_range");
    if (twoContainer) twoContainer.innerHTML = "";
    // localStorage.removeItem("two_range_info");
  
    document.querySelectorAll(".two_range").forEach(group => {
      const titleEl = group.querySelector(".quetion_text");
      if (!titleEl) return;
      const title = titleEl.textContent.trim();
  
      const ranges = group.querySelectorAll('input[name^="contact[two_range"]');
      if (ranges.length < 2) return;
  
      const [range1, range2] = ranges;
      const update = () => saveAndDisplay(twoContainer, "two_range_info", title, { first: range1.value, second: range2.value });
  
      range1.addEventListener("input", update);
      range2.addEventListener("input", update);
      update();
    });
  
    // ====== FOUR RANGE ======
    const fourContainer = document.querySelector(".hardware_pdp_four_range");
    if (fourContainer) fourContainer.innerHTML = "";
    // localStorage.removeItem("four_range_info");
  
    document.querySelectorAll(".four_range").forEach(group => {
      const titleEl = group.querySelector(".quetion_text");
      if (!titleEl) return;
      const title = titleEl.textContent.trim();
  
      const ranges = group.querySelectorAll('input[name^="contact[four_range"]');
      if (ranges.length < 4) return;
  
      const [r1, r2, r3, r4] = ranges;
      const update = () => saveAndDisplay(fourContainer, "four_range_info", title, { first: r1.value, second: r2.value, third: r3.value, fourth: r4.value });
  
      r1.addEventListener("input", update);
      r2.addEventListener("input", update);
      r3.addEventListener("input", update);
      r4.addEventListener("input", update);
      update();
    });

  // ==== RADIO BUTTON ====
  const radioContainer = document.querySelector(".hardware_pdp_radio");
  if (radioContainer) radioContainer.innerHTML = "";
  // localStorage.removeItem("radio_info");
  
  document.querySelectorAll(".single_radio").forEach(group => {
    const titleEl = group.querySelector(".quetion_text");
    if (!titleEl) return;
    const title = titleEl.textContent.trim();
  
    const radios = group.querySelectorAll('input[name="contact[single_radio]"]');    
    if (!radios.length) return;
  
    const update = () => {
      const checked = group.querySelector('input[name="contact[single_radio]"]:checked');    
      if (checked) {
        // Convert value string to object of index=char
        // const valueObj = {};
        // checked.value.split("").forEach((char, i) => valueObj[i] = char);
        saveAndDisplay(radioContainer, "radio_info", title, checked.value );
      }
    };

    radios.forEach(radio => {
      radio.addEventListener("change", update);
    });
    update();
  });
  
   // ==== CHECKBOX RESULT =====
  const checkboxContainer = document.querySelector(".hardware_pdp_checkbox");
  if (checkboxContainer) checkboxContainer.innerHTML = "";
  // localStorage.removeItem("checkbox_info");
  
  document.querySelectorAll(".single_checkbox").forEach(group => {
    const titleEl = group.querySelector(".quetion_text");
    if (!titleEl) return;
    const title = titleEl.textContent.trim();
  
    const checkboxes = group.querySelectorAll('input[name="contact[single_checkbox]"]');
    if (!checkboxes.length) return;
  
    const update = () => {
      const checkedValues = Array.from(checkboxes)
        .filter(cb => cb.checked)
        .map(cb => cb.value);
  
      if (checkedValues.length > 0) {
        saveAndDisplay(checkboxContainer, "checkbox_info", title, checkedValues);
      } else {
        // remove entry if nothing checked
        const data = JSON.parse(localStorage.getItem("checkbox_info") || "[]");
        const idx = data.findIndex(item => item.title === title);
        if (idx > -1) {
          data.splice(idx, 1);
          localStorage.setItem("checkbox_info", JSON.stringify(data));
        }
        const el = checkboxContainer?.querySelector(`[data-title="${title}"]`);
        if (el) el.remove();
      }
    };
  
    checkboxes.forEach(cb => cb.addEventListener("change", update));
    update(); 
  });
  
  // result step 12
  const accordian_twelth = document.querySelectorAll(".Twelfth_step .accordion-image-title-content-item .accordion_input");
  // localStorage.removeItem('twelth_accordian_info');
  accordian_twelth?.forEach(input => {
    input?.addEventListener("change", function (inp) {
      const wrapper = input.closest(".accordion-image-title-content-item-inner");
      const acc_title = wrapper?.querySelector(".build-title")?.innerHTML;
      const acc_content = wrapper?.querySelector(".accordion-image-content")?.innerHTML;  
      let acc_stored = [];
      if( acc_title || acc_content){
        acc_stored.push({ acc_title: acc_title,acc_content: acc_content});
        localStorage.setItem("twelth_accordian_info", JSON.stringify(acc_stored));
        let saved_acc = JSON.parse(localStorage.getItem("twelth_accordian_info") || "[]");
        if (saved_acc.length > 0) {
          const { acc_title, acc_content } = saved_acc[0];
          const acc_show_title = document.querySelector(".hardware_pdp_multi_checkbox .show_pdp_title");
          const acc_show_content = document.querySelector(".hardware_pdp_multi_checkbox .show_pdp_content");
          if (acc_show_title) acc_show_title.innerHTML = acc_title;
          if (acc_show_content) acc_show_content.innerHTML = acc_content;
        }
      }    
    });
  });
    // credit step
  summaryCheckboxAddLoac();
  
// jk not add in the t3-, rs
  // credit in range dtaa show
  function slider_storage(slider){   
    console.log("slider rs",slider) 
    const wrapper = slider.closest(".checkbox-accordion");
    const near_child = slider.closest("[value-of-details]")?.getAttribute("value-of-details");
    
    if (!wrapper) return;
    const checkedChildren = wrapper.querySelectorAll(".child_parent:checked");
    if (!checkedChildren.length) return;

    const parentHeading = slider.closest(".show_hidden_content")?.getAttribute("data-heading-acc");
    let storedData = JSON.parse(localStorage.getItem("credit_accordion") || "[]");

    storedData.forEach(parent => {
      
      if (parent.acc_title === parentHeading && parent.subObjects) {
        checkedChildren.forEach(checkbox => {
          
          const childTitle = checkbox.value;          
          parent.subObjects.forEach(child => {   
            
            
            if (child.acc_title === childTitle) {  
              
              if(childTitle == near_child) child.qty = slider.value; 
            }
          });
        });
      }
    });
    localStorage.setItem("credit_accordion",JSON.stringify(storedData)
    );    
  }

  document.querySelectorAll(".slider.custom-range").forEach(slider => {
    slider_storage(slider);
    slider.addEventListener("change", function () {
      slider_storage(slider);
    });
  });
// end

  // credit step 1 in accordion and also xs step 5 page result 
  const acc_main_title = document.querySelectorAll(".configure-form-product-filter-inner .credit_radio");
  const main_credit = document.querySelector(".credit_main_title"); 
  // localStorage.removeItem('credit_accordion_title');
  acc_main_title?.forEach(input => {
    input?.addEventListener("change", function () {    
      const input_text = input.dataset.text;
      
      if(!input_text) return;
      
      let storedData = JSON.parse(localStorage.getItem("credit_accordion_title") || "[]");
      storedData = (storedData !== input_text);
      // Remove the corresponding HTML elements
        if (main_credit) main_credit.innerHTML = "";
  
      if (storedData !== input_text) {
        localStorage.setItem("credit_accordion_title", JSON.stringify(input_text));
        main_credit.innerHTML= input_text;
      }
    });
  });
  
  // step 2 in last accordion selecet 
  const accordian_buttons = document.querySelectorAll(".tab_with_data_radio");
  accordian_buttons?.forEach(button => {
      button?.addEventListener("change", function (radio) {  
          const allTabs = [...document.querySelectorAll(".tab-product-item")];
          allTabs?.map(tab => tab.classList.remove("active"));
            button?.closest(".tab-product-item")?.classList.add("active");
            const producthandle = this.dataset.tabProduct;
            if(producthandle){
              const selected_card = button.closest('.grid__item'); 
              let input_val = selected_card?.querySelector(".quantity__input").value || 1;  
              if(input_val){
                input_val = parseInt(input_val) + 1
                const qty_inp = selected_card.querySelector(".quantity__input"); 
                if(qty_inp)qty_inp.value = input_val;
              }   

              const step_no = get_the_step_no(this);

              renderSelectedProducts(producthandle, radio.name, input_val, step_no);
            }         
      });
    });
   
  // // step 2 data set in result hidden inp
  // const step_3_global = document.querySelectorAll(".second-step details");

  // step_3_global.forEach(detail => {
  //   detail.addEventListener("toggle", function () {
  //     const parent_block = detail.closest(".cust-form-wrapp"); 
  //     const show_hidden_field = detail.querySelector(".step_2_result_title");

  //     if (!show_hidden_field) return;
  //     if (this.open) {
        
  //       show_hidden_field.removeAttribute("disabled");        
  //     } else {
        
  //       show_hidden_field.setAttribute("disabled", "");        
  //     }
  //   });
  // });

function getAllClosest(el, selector) {
  const matches = [];
  while (el) {
    if (el.matches?.(selector)) {
      matches.push(el);
    }
    el = el.parentElement;
  }
  return matches;
}

function handleAnimationFrame(datas){
  

  let data = datas.closest("[pre-data-pre-products]") || datas;  
  let data_attr = null;  
  if(datas.closest("[pre-data-pre-products]")){
      let check_preselecte_sensor = datas.closest("[pre_product_sensoren]") || null;
      let check_preselecte_kabel = datas.closest("[pre_product_kabel]") || null;
      let is_contains_sensor = datas.getAttribute("data-collection").includes("sensor");
      let is_contains_kabel = datas.getAttribute("data-collection").includes("kabel");
      
      
      if(check_preselecte_sensor || check_preselecte_kabel ){
        if(is_contains_sensor && check_preselecte_sensor){
           data_attr = check_preselecte_sensor.getAttribute('pre_product_sensoren');
        }else if(is_contains_kabel && check_preselecte_kabel){
          data_attr = check_preselecte_kabel.getAttribute('pre_product_kabel');
        }
      }
        
  }
  if(!data) return;  
  const normalizeHandle = (str) =>str.toString().trim().toLowerCase().replace(/®/g, '').replace(/\s+/g, '');    
  let collection = data.getAttribute("pre-data-pre-products") !== null ? data : null;  

  
  if(!collection && data_attr) collection = data;

  if( collection !=  null){  
    let preProductAttrsen_keb_ = "";
    const is_clicked_pre_selected = document.querySelector(".clicked_according");
    if(is_clicked_pre_selected !=  null){   
        if(data_attr){
          preProductAttrsen_keb_ = data_attr || '';             
        } else{
          preProductAttrsen_keb_ = collection?.getAttribute('pre-data-pre-products') || '';             
        }             
        preProductAttrsen_keb = preProductAttrsen_keb_.split(",").map(item => {
          const [handle, quantity] = item.split("^_^");
          return {
            handle: normalizeHandle(handle),
            quantity: quantity || 1
          };
        });
         

        const cards = collection.querySelectorAll("[data-product-handle]");                        
        cards.forEach(card => {              
          const rawHandle = card.getAttribute("data-product-handle");
          const productHandle = normalizeHandle(rawHandle);    
          const matched = preProductAttrsen_keb.find(p => p.handle === productHandle);
          
          if (!matched) return;
      
          const qtyInput = card.querySelector("input.quantity__input.quantity_product_card");
           const qty_val = parseInt(matched.quantity);
          if (qtyInput) {
            qtyInput.value ="";            
            // qtyInput.value = matched.quantity;
          }

          const variantCheckbox = card.querySelector("input.variant-checkbox[type='checkbox']");    
          if (variantCheckbox && !variantCheckbox.checked) {                
            for (let i = 0; i < qty_val; i++) {
              variantCheckbox.click();
            }            
          }
        });   
    }   
  }else{    
    const main_product = document.querySelector(".accordion__content.clicked_according");      
    const preProductAttrKarten = main_product?.querySelector("[pre_product_karten]")?.getAttribute("pre_product_karten") || '';  
    
    
    
    if (!preProductAttrKarten){
      SpinnerRemove();
        return;
    }                

   const parsedProducts = preProductAttrKarten.split(",").map(item => {
      const [handle, quantity] = item.split("^_^");
      return {
        handle: normalizeHandle(handle),
        quantity: quantity || 1
      };
    });
    
    const cards = data.querySelectorAll("[data-product-handle]");    
    cards.forEach(card => {              
      const rawHandle = card.getAttribute("data-product-handle");
      const productHandle = normalizeHandle(rawHandle);    
      const matched = parsedProducts.find(p => p.handle === productHandle);
      if (!matched) return;

      const qtyInput = card.querySelector("input.quantity__input.quantity_product_card");
      if (qtyInput) {
        qtyInput.value ="";
        
        qtyInput.value = matched.quantity;       
      }
      const variantCheckbox = card.querySelector("input.variant-checkbox[type='checkbox']");    
      if (variantCheckbox && !variantCheckbox.checked) {      
        variantCheckbox.click();      
      }
    });
  }   
   SpinnerRemove();
}

  //========== selected filter data show in mobile ============//
class selecetdProductTagMobile extends HTMLElement {
  constructor() {
    super();   
    this.init();
  }

  init() {
    this.selecetdPorductTagText(this);
  }

  async selecetdPorductTagText(current_this) {
    const tabInputs = current_this?.querySelectorAll("input.button_tab_inp");
    const variantRadios = current_this?.querySelectorAll(".select_product input.variant-radio");   

    function handleSelection(input) {
      const card = input.closest(".grid__item");
      const tab = input.closest(".selecetd_product_tab");
      const details = card?.closest(".pro-card-details");
      const label = card?.querySelector(".selected_product_tag");
      const qtyInput = card?.querySelector(".quantity__input.quantity_product_card");
  
      const meta_filed_wise = input.closest("metawise-variant-selector");
      if (meta_filed_wise) return;
      if (!tab || !card) return;
  
      const isFirst = tab.hasAttribute("data-first-collection");
      const isSecond = tab.hasAttribute("data-second-collection");
  
      const handle = input.dataset.varHandle;
      const name = input.name;
      const labelText = input.dataset.tagText || "";
      const qty = parseInt(qtyInput?.value || "1", 10);    
      
      let stored = JSON.parse(localStorage.getItem("selectedProducts")) || [];  
      const index = stored.findIndex(item => item.handle === handle);     
      let input_val = card.querySelector(".quantity__input").value || 1;  
      if(input_val && !card.classList.contains("active")){
        input_val = parseInt(input_val) + 1
        const qty_inp = card.querySelector(".quantity__input"); 
          if(qty_inp)qty_inp.value = input_val;
      }   
      const step_no = get_the_step_no(input);
      
      if (label && label.innerHTML.trim() === "") {      
        // is_selected_any_product(input);
        label.innerHTML = labelText;
  
        // Add new data if not already in localStorage
        if (index === -1) {
          stored.push({
            handle,
            name,
            type: isFirst ? "sensor" : isSecond ? "kabel" : "other",
            quantity,
          });
        }
  
        // UI Update
        if (isFirst) {
          details?.querySelector(".after_sensor")?.classList.add("active");
          details?.querySelector(".befor_sensor")?.classList.remove("active");
        }
        if (isSecond) {
          details?.querySelector(".after_cabel")?.classList.add("active");
          details?.querySelector(".befor_cabel")?.classList.remove("active");
        }
  
        renderSelectedProducts(handle, name, input_val, step_no);
      } else {        
      // If label has value (means already selected → remove)
        // isalready_selected_any_product(input);

        if (label) label.innerHTML = "";
  
        if (index !== -1) {
          stored.splice(index, 1);
        }
  
        // UI Reset
        if (isFirst) {
          details?.querySelector(".after_sensor")?.classList.remove("active");
          details?.querySelector(".befor_sensor")?.classList.add("active");
        }
        if (isSecond) {
          details?.querySelector(".after_cabel")?.classList.remove("active");
          details?.querySelector(".befor_cabel")?.classList.add("active");
        }
      }
  
      localStorage.setItem("selectedProducts", JSON.stringify(stored));
  
      //  Quantity listener (live update)
      if (qtyInput && !qtyInput.dataset.bound) {
        qtyInput.dataset.bound = "true";
        qtyInput.addEventListener("input", function () {
          const newQty = parseInt(this.value) || 1;
          let stored = JSON.parse(localStorage.getItem("selectedProducts")) || [];
          const idx = stored.findIndex(item => item.handle === handle);
          if (idx !== -1) {
            stored[idx].quantity = newQty;
            localStorage.setItem("selectedProducts", JSON.stringify(stored));
            
          }
        });
      }
    }
  
    tabInputs?.forEach(input => {
      input.addEventListener("change", () => handleSelection(input));
    });
  
    variantRadios?.forEach(input => {
      input.addEventListener("click", () => handleSelection(input));
    });
  }
}

class customfilterMobile extends selecetdProductTagMobile {
  constructor() {
    super();   
    // this.init();
  }

  init() {
    this.getInputForEventTarget();
  }

  async getInputForEventTarget(filterParam = null, selectedValue = null) {   
     const filter_data = this.querySelector(".filter-data");        
     
    if(filter_data){     
      const collectionInfo = await this.getcollectionInfo(filter_data.dataset.collection);
      // 
      if(collectionInfo){
        filter_data.innerHTML = "";

        filter_data.appendChild(collectionInfo); 
        await this.selecetdPorductTagText(this);      
      }
    }    
  }

  async getcollectionInfo(handle) {
    try {
      const is_que = handle.includes('?');
      var params = ""; 
      if(is_que){
        var params = "&";   
      }else{
        var params = "?";  
      }
      const response = await fetch(`${handle}${params}view=custom_filter`);    
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }
      const productHTML = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(productHTML, 'text/html');
      const filter_data = doc.querySelector(".tag_filter_list_scadas_mobile");
      return filter_data;
  
    } catch (error) {
      console.error('Error fetching product info:', error);
      return null;
    }
  }

}
if (!customElements.get('cust-filter-mobile')) {
  customElements.define('cust-filter-mobile', customfilterMobile);
}

class customfilterMobileProduct extends selecetdProductTagMobile {
  constructor() {
    super();   
    // this.init();
  }

  init() {
    this.collectionid = this.getAttribute('data-col-api-id') || null;
    if(this.collectionid){
       this.getdataforapi();       
    }else{
          this.getInputForEventTarget();
    }
  }

  async getInputForEventTarget(filterParam = null, selectedValue = null) {   
     const filter_data = this.querySelector(".filter-data");   
     
    if(filter_data){             
      const collectionInfo = await this.getcollectionInfo(filter_data.dataset.collection);      
      if(collectionInfo){
        filter_data.innerHTML = "";

        filter_data.appendChild(collectionInfo); 
        await this.selecetdPorductTagText(this);       
      }
    }    
  }

  async getcollectionInfo(handle) {
    try {
      const is_que = handle.includes('?');
      var params = ""; 
      if(is_que){
        var params = "&";   
      }else{
        var params = "?";  
      }
      const response = await fetch(`${handle}${params}view=custom_filter`);    
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }
      const productHTML = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(productHTML, 'text/html'); 
      const filter_data = doc.querySelector(".tag_filter_list_scadas_mobile");
      return filter_data;
  
    } catch (error) {
      console.error('Error fetching product info:', error);
      return null;
    }
  }

  async productwisefiltershow(e, This) {  
      // Group values by key
      const grouped = new Map();  
      this.querySelectorAll(".selecetd_filter:checked").forEach((input) => {
        const key = input.dataset.filterParam;
        const type = input.dataset.listCheck ?? input.dataset.type ?? "list";
        const value = input.value.trim();
  
        if (!key || !value) return;  
        if (!grouped.has(key)) {
          grouped.set(key, { key, type, values: [] });
        }
        grouped.get(key).values.push(value);
      });
  
      // Build ONLY the "filter" array
      const filter = Array.from(grouped.values()).map((item) => ({
        key: item.key,
        type: item.type,
        value: item.values.join(",")
      }));
        
      this.data = JSON.parse(this.dataset.metafildsJsinApi); 
      this.data.filter = filter;     
      
       if(!this.data.product_id) this.data = updateMainObject(this.data, this.data.filter); 
       if(this.data.get_main_first && window.firstIdStored) this.data.product_id =  window.firstIdStored;
       
      const collectionInfo = await load_product_api(this.data);          
      SpinnerAdd();
      
      await this.productHtmlUpdate(collectionInfo);
      SpinnerRemove();     
  }
  

    // remove filter function function 
  async RemoveFilter(event, This,Key){
      event.preventDefault();
      this.data = {
        ...this.data,
        metafields: this.data.metafields.filter(item => item.key !== Key),
        ...(this.data.filter && {
          filter: this.data.filter.filter(item => item.key !== Key)
        })
      };
      this.collection_name = this.product_data.querySelector("[data-first-collection]");     
              const filter_data = this.getAttribute("data-collection-url");                
              const collectionInfo = await load_product_api(this.data);                 
              SpinnerAdd();
              await this.productHtmlUpdate(collectionInfo);  
              SpinnerRemove();                    
                                       
                    This.closest('ul')?.querySelectorAll(".selecetd_filter").forEach(function(checkbox) {
                      checkbox.checked = false;                       
                    });                            
  }

  // get product base on custom API
  async getdataforapi() {   
     this.product_data = this.closest('metawise-variant-selector') || null;           
    if(this.product_data){       
      const el = this.product_data.querySelector('[data-product-id-cust-api]') || null;      
      if(!el) return
         this.data = JSON.parse(this.dataset.metafildsJsinApi); 
         this.collection_name = this.product_data.querySelector("[data-first-collection]");     
        const filter_data = this.getAttribute("data-collection-url");
        const window_firstIdStored = this.data;
        
        if(this.data.get_main_first && window.firstIdStored) {
          this.data.product_id =  window.firstIdStored;
        
        }

        const collectionInfo = await load_product_api(this.data); 
        //  SpinnerAdd(); 
        
        await this.productHtmlUpdate(collectionInfo);     
                             
                //  const filter_vall = await this.productwisefiltershow();
            }    
  }

  async productHtmlUpdate(collectionInfo){
    const container = this.closest('metawise-variant-selector')?.querySelector(this.getAttribute('data-tab-selector')); 
    this.is_multi_step = this.closest("configure-form")?.querySelector(".sixth_step .show_selecetd_collaps_product");  
    
    const block_id = this.is_multi_step?.getAttribute("data-block-id");   
    if (!container) return;
    if(!collectionInfo){
      container.innerHTML = "product not found";  
    }

    let items = [];
    // Check Array or Object
    
      if (Array.isArray(collectionInfo)) {
        items = collectionInfo;     // direct array
      } else if (typeof collectionInfo === "object") {
        items = Object.entries(collectionInfo);                  
      } else {
        console.warn("collectionInfo is neither array nor object");
        return;
      }                      
      container.innerHTML = "";    
        SpinnerAdd();       
      // for (let item of items) {
      for (let [index, item] of items.entries()) {
          let handle;                   
        if (Array.isArray(collectionInfo)) {
          handle = item;
        } else {
          handle = item[1];  // object case value
        }
        var cardEl = ""  

        const wrapper = document.createElement("div");
        wrapper.className = `grid__item filters-${this.collection_name} cust-product-card-wrapper`;        
        if(this.is_multi_step){
          cardEl = await multi_acc_card_product(handle,block_id,index);            
          if (!cardEl) continue;
        }else{
          cardEl = await cardProduct(handle);            
          if (!cardEl) continue;
        }

        const productId = cardEl.getAttribute("data-product-id");        
        wrapper.id = `filters-${this.collection_name}-${productId}`;
        wrapper.appendChild(cardEl);
        container.appendChild(wrapper);
      }      
      // pre selected
      const is_remove = true;
      // filteredProductshow(this,is_remove);
      
      handleAnimationFrame(container);
      const slotData = JSON.parse(localStorage.getItem("slotproduct") || "[]");
      const render_section = document.body.classList.contains("is_rerender_step_fourth");
       
       if (Array.isArray(slotData) && slotData.length > 0 && render_section ) {
         const slotHandles = new Set(slotData.map(p => p.handle));                             
          document.querySelectorAll(".main-tab-products-content .product-card-wrapper").forEach(card => {      
            
                if (!slotHandles.has(card.dataset.handle) && cart.closest('.sixth-step')) return;
                card.querySelector(".variant-checkbox.cust_btn_select")?.click();
          });   
          document.body.classList.remove("is_rerender_step_fourth")
       }
  }
}
if (!customElements.get('cust-filter-mobile-product')) {
  customElements.define('cust-filter-mobile-product', customfilterMobileProduct);
}

function customAddToCart(product, openDrawer) {  
  fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { "Accept": "application/json", "Content-Type": "application/json" },
      body: JSON.stringify(product)
  })
  .then(response => {    
    if (!response.ok) {throw new Error('Network response was not ok');}
  })
  .then(response => {
    
  })
  .catch(error => {
    console.error('Error:', error);
  })
  .finally(() => {
    document.querySelector('cart-drawer')?.refresh(true);    
  });
}


function removeSpecificConfigProduct(variantId) {
  const is_avalible = document.querySelector("[data-is_confi_item='"+variantId+"']") || null;
  if(is_avalible){
    is_avalible.querySelector("cart-remove-button .button")?.click();
    document.querySelector('cart-drawer')?.refresh(true);   
  }
}


class filterInoptionSelectMobile extends selecetdProductTagMobile {
  constructor() {
    super();   
    // this.init();
  }

  connectedCallback() {}

  init() {
    this.addEventListener('change', async (e) => {
      if (e.target.matches('.selecetd_filter')) {
        const selectedInput = e.target;
        const selectedValue = selectedInput.value;
        // const filterParam = selectedInput.dataset.filterParam; 
        const allSelectedFilters = {};

        const dropdown =  selectedInput.closest("ul.filter-radio-list");         
        dropdown?.classList.remove("active")      

        // Get all selected inputs globally
        this.tab_filter = this.closest(".scadas_mobile_filter_wrapp");        
        this.tab_filter.querySelectorAll('.selecetd_filter:checked').forEach(input => {
          const filterParam = input.dataset.filterParam;
          const value = input.value;
          if (filterParam && value) {
            allSelectedFilters[filterParam] = value;
          }
        });
        // if (selectedValue && filterParam) {
          await this.getInputForEventTarget(allSelectedFilters);
          
        // }
      }
    });
  }

  async getInputForEventTarget(allSelectedFilters) {  
     const filter_data = this.getAttribute("data-collection-url"); 
     const filter_clo_data = this.closest(".scadas_filter_mobile");
     const product_grid = filter_clo_data.querySelector(".tab-section_product");  
     if(!filter_data) return;
       const collectionHandle = filter_data;
      if (!collectionHandle) {
        console.warn('Missing collection handle');
        return;
      }

    let url = `${collectionHandle}?view=custom_filter`;
    if(url){
      // Add all selected filters to URL
      Object.entries(allSelectedFilters).forEach(([param, val]) => {
      url += `&${encodeURIComponent(param)}=${encodeURIComponent(val)}`;
    });

    }   
    if(filter_data){ 
      const collectionInfo = await this.getcollectionInfo(url);
        if(collectionInfo){
          product_grid.innerHTML = "";
          product_grid.appendChild(collectionInfo)
          const select_filter_tag = this.closest("cust-filter-mobile"); 
          await this.selecetdPorductTagText(select_filter_tag);
          
          handleAnimationFrame(this);      
        }
    }    
  }

  async getcollectionInfo(handle) {
    try {
      const response = await fetch(`${handle}`);      
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }
      const productHTML = await response.text();      
      const parser = new DOMParser();
      const doc = parser.parseFromString(productHTML, 'text/html');
      const filter_data = doc.querySelector(".cust-product-card-wrapper");      
      return filter_data;
  
    } catch (error) {
      console.error('Error fetching product info:', error);
      return null;
    }
  }
}
if (!customElements.get('filter-option-select-mobile')) {
  customElements.define('filter-option-select-mobile', filterInoptionSelectMobile);
}

// =============== Dynamic Metafield Slot Selector =============== //
class MetaVariantSelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
    const observer = new MutationObserver(() => {
      this.init();
    });
    observer.observe(this, { childList: true, subtree: true });
  }

  init() {
    this.slotInputs = Array.from(this.querySelectorAll(".meta-slot-input"));      
    this.totalSlots = this.slotInputs.length;

      this.slotRules = [
    { max: 7, value: "8" },
    { max: 11, value: "14" },
    { max: 13, value: "20" },
    { max: 13, value: "26" }
  ];

    
    this.setupSlotInputChange(); 
    this.setupRadioListeners();
    // this.setupcheckboxListeners();
    this.checkInpNoProductDisable();
    this.popup_show_close();
    this.extraQtyChangeSku();
    // this.pagination_click();
    // this.checkQtyButtonState();
  }

  handleSelection(input) {
    const card = input.closest(".grid__item");
    const tab = input.closest(".selecetd_product_tab");
    const details = card?.closest(".pro-card-details");
    const label = card?.querySelector(".selected_product_tag");
    const qtyInput = card?.querySelector(".quantity__input.quantity_product_card");    

    const isFirst = tab?.hasAttribute("data-first-collection");
    const isSecond = tab?.hasAttribute("data-second-collection");

    const handle = input.dataset.varHandle;
    const name = input.name;
    const labelText = input.dataset.tagText || "";
    const quantity = parseInt(qtyInput?.value || "1", 10);    
    
    let stored = JSON.parse(localStorage.getItem("selectedProducts")) || [];
    let stored_slot = JSON.parse(localStorage.getItem("slotproduct")) || [];  

    const index = stored.findIndex(item => item.handle === handle);   
    const index_slot = stored_slot.findIndex(item => item.handle === handle);  
    if (label && label.innerHTML.trim() === "") {
      
      // is_selected_any_product(input);
      label.innerHTML = labelText;
      const step_no = get_the_step_no(this);
      // Add new data if not already in localStorage
      if (index === -1) {
        stored.push({
          handle,
          name,
          quantity,
          step_no          
        });
      }

      // UI Update
      if (isFirst) {
        details?.querySelector(".after_sensor")?.classList.add("active");
        details?.querySelector(".befor_sensor")?.classList.remove("active");
      }
      if (isSecond) {
        details?.querySelector(".after_cabel")?.classList.add("active");
        details?.querySelector(".befor_cabel")?.classList.remove("active");
      }

      let input_val = card.querySelector(".quantity__input").value;  
      if(input_val && !card.classList.contains("active")){
        input_val = parseInt(input_val) + 1
        const qty_inp = card.querySelector(".quantity__input"); 
        if(qty_inp)qty_inp.value = input_val;
      }       
      renderSelectedProducts(handle, name, input_val, step_no);
    } else {        
      

      if (label) label.innerHTML = "";

      if(index_slot !== -1){
        stored_slot.splice(index, 1);
      }

      if (index !== -1) {        
        stored.splice(index, 1);
      }

      // UI Reset
      if (isFirst) {
        details?.querySelector(".after_sensor")?.classList.remove("active");
        details?.querySelector(".befor_sensor")?.classList.add("active");
      }
      if (isSecond) {
        details?.querySelector(".after_cabel")?.classList.remove("active");
        details?.querySelector(".befor_cabel")?.classList.add("active");
      }
    }

    localStorage.setItem("selectedProducts", JSON.stringify(stored));
    localStorage.setItem("slotproduct", JSON.stringify(stored_slot));

    //  Quantity listener (live update)
    if (qtyInput && !qtyInput.dataset.bound) {
      qtyInput.dataset.bound = "true";
      qtyInput.addEventListener("input", function () {
        const newQty = parseInt(this.value) || 1;
        // let stored = JSON.parse(localStorage.getItem("selectedProducts")) || [];
        const idx = stored.findIndex(item => item.handle === handle);
        const idx_slot = stored.findIndex(item => item.handle === handle);

        if(idx_slot !== -1){
          stored_slot[idx_slot].quantity = newQty;
          localStorage.setItem("slotproduct", JSON.stringify(stored_slot));
        }

        if (idx !== -1) {
          stored[idx].quantity = newQty;
          localStorage.setItem("selectedProducts", JSON.stringify(stored));
        }
      });
    }
  }

  getNextEmptySlot() {
    return this.slotInputs.find(input => !input.checked);
  }

 getNextAssignSlot(slotInputs,itspopup_rs) {
   console.log("window.limit",window.limit,"itspopup_rs__",itspopup_rs);
    
    // if(itspopup_rs){

    
   if (window.start_canvas >= window.limit) {
          // rs_popuup_open();          
        }else{
           window.start_canvas ++;

            console.log("window.start_canvas befor update",window.start_canvas);
                      // First check with windows.start
                      const startSlot = this.slotInputs.find(input => {
                        const slot = input.getAttribute("data-slot")?.toString().trim();
                        return !input.checked && Number(slot) === Number(window.start_canvas); 
                      });

                      // If found, return it
                      if (startSlot) {

                         const isMatched = this.slotRules.some(rule => {
                            return Number(rule.value) === window.start_canvas;
                          });
                          if (isMatched) {
                            
                            const checkedInput = [document.querySelectorAll(".popup_rs .popup_option:not(.disabled) .is_checked")].find(input => !input.checked);
                            const allSelected = !!checkedInput;
                            if(allSelected) {   
                              // disablePopupInputs(checkedInput[0]); 
                            }

                          }

                        return startSlot;
                      }else{

                          const isMatched = this.slotRules.some(rule => {
                            return Number(rule.value) === window.start_canvas;
                          });
                          if (isMatched) {
                            window.start_canvas ++;
                          }

                           const startSlot_check_first_fill = this.slotInputs.find(input => {
                              const slot = input.getAttribute("data-slot")?.toString().trim();
                              return !input.checked && Number(slot) === Number(window.start_canvas); 
                            });
                            if(startSlot_check_first_fill){
                                return startSlot_check_first_fill;
                            }else{
                              console.log("window.start_canvas sloat not found.",window.start_canvas)
                              return null;
                            }
                            
                      }


                      //  return this.slotInputs.find(input => !input.checked) || null;
      }
      // }else{
      //   rs_popuup_open();
      //   return null;
      // }
 }

 getNextAssignSlotPre(main_input) {
  this.slotInputs = Array.from(this.querySelectorAll(".meta-slot-input"));

  if(!main_input) return;
  if(parseInt(main_input.Value) >= 5){
      main_input.closest('.card-information').classList.add('limet_over');
    }

  const nextSlotInput = this.slotRules.reduce((found, rule) => {
    if (found) return found;

    return this.slotInputs.find(input => {
      const slot = input.getAttribute("data-slot")?.toString().trim();

      return (
        Number(slot) === Number(rule.value) &&
        !input.checked
      );
    }) || null;

  }, null);

  if(nextSlotInput){
    const checkedInput = [document.querySelectorAll(".popup_rs .popup_option:not(.disabled) .is_checked")].find(input => !input.checked);
    const allSelected = !!checkedInput;
                     if(allSelected) {   
                      disablePopupInputs(checkedInput[0]); 
                    }
                    
    window.limit += 6; 
   return nextSlotInput
  }else{
    return null;
  }

  // console.log(nextSlotInput);
  
}


  getSlotByHandle(handle) {
    return this.slotInputs.filter(input => {
      const slot = input.closest(".slot");
      return slot?.dataset.metaHandle === handle;
    });
  }
  
  fillSlot(index, parent, selector, input, variantId, handle, productTitle) {   
    console.log("fillslot callled",input);
    const imgSrc = selector.dataset.slotImage;  
    const is_image_meta = selector.dataset.productIsImage;              
    const slotData = [{
      slotTop: selector.dataset.slotTop? Math.round(Number(selector.dataset.slotTop)): null,  
      slotRight: selector.dataset.slotRight? Math.round(Number(selector.dataset.slotRight)): null,    
      slotHeight: selector.dataset.slotHeight? Math.round(Number(selector.dataset.slotHeight)): null,    
      slotWidth: selector.dataset.slotWidth? Math.round(Number(selector.dataset.slotWidth)): null
    }];            

        const slot_number =  parseInt(input.getAttribute('data-slot'),10) || null;

        // console.log("slot_number_RS_input",input);
        // console.log("slot_number_RS",slot_number);

    if(is_image_meta == "true"){      
      if (!imgSrc) return;           
      const canvas_groupid = uploadImageFromURL(window.canvas, imgSrc, slotData,slot_number);
      
      if(canvas_groupid){
       select_canvo_main(canvas_groupid);
         input.setAttribute(`data-canvas-group-id` , canvas_groupid);
         input.classList.add('active');
      }
    }
  
    input.checked = true;
    input.value = variantId;
    const slot_parent = input.closest(".slot");
    const slot_title = slot_parent?.querySelector(".slot-main-tile").innerText.trim();
    const slot_no = slot_parent?.querySelector(".slot-tile").innerText.trim();
    console.log("input_input",slot_title,"slot_no",slot_no);
    const slot = input.closest(".slot");


    slot.setAttribute("data-meta-handle", handle);

    const titleEl = slot.querySelector(".slot-title");
    const removeEl = slot.querySelector(".slot-controls")?.classList.remove("hidden");
    const removeInfoBtn = slot.querySelector(".slot-pdp-info-button")?.classList.remove("hidden");
    const select_msg = slot.querySelector(".select_third_product")?.classList.add("hidden");
    if (titleEl) titleEl.textContent = productTitle;
    const selected_title = slot.querySelector(".status_text_info")?.getAttribute("selecetd_title");
    slot.querySelector(".status_text_info").innerHTML = selected_title;
    updatePopupRadioStates();
    let stored = JSON.parse(localStorage.getItem("selectedProducts")) || [];    
    const matched = stored.find(item => item.handle === handle);

    if (matched) {
      console.log("matched....",matched)
      matched.slot_title = `${slot_title} ${slot_no}`;
      localStorage.setItem("selectedProducts", JSON.stringify(stored));
      console.log("store..",stored)
    }

  }

  clearSlot(slotInput, index) {
    console.log("clearslot rs");
    const slot = slotInput.closest(".slot");
    const metaHandle = slot.dataset.metaHandle;

    //image delete in image
    const imgSrc = slotInput.dataset.slotImage;  
    const is_image_meta = slotInput.dataset.productIsImage;      
    const get_image_attr = slotInput.getAttribute(`data-canvas-group-id`) || null;    
    if(get_image_attr){
      deleteObjectById(window.canvas,get_image_attr);
    }


    // check if any var-id matches then remove that div
    const sixth_step = document.querySelector(".show_selecetd_acc_product");
    const six_id = sixth_step?.querySelectorAll("metawise-variant-selector[data-product-var-id]");
    const currentVarId = slotInput.value;    
    Array.from(six_id).forEach(el => {
      if (el.dataset.productVarId === currentVarId) el.remove();         
    });

    slotInput.checked = false;
    slotInput.value = "";
   slot.removeAttribute('data-meta-handle');
  
    const titleEl = slot.querySelector(".slot-title");
    if (titleEl) titleEl.textContent = "";
    const removeEl = slot.querySelector(".slot-controls")?.classList.add("hidden");
    const removeInfoBtn = slot.querySelector(".slot-pdp-info-button")?.classList.add("hidden");
    
    const select_msg = slot.querySelector(".select_third_product")?.classList.remove("hidden");
  
    const selected_title = slot.querySelector(".status_text_info")?.getAttribute("unselected_title");
    slot.querySelector(".status_text_info").innerHTML = selected_title;  
  
    // --- 2. Clear card-level items ONLY if no slots remain for this handle ---
    if (metaHandle) {  
      const allSlots = Array.from(document.querySelectorAll(`.slot[data-meta-handle="${metaHandle}"]`));                   

      // Check if any slot is still filled
      const stillFilled = allSlots.some(s => {
        const input = s.querySelector(".meta-slot-input");        
        return input && input.value !== "";
      });
  
      // If ANY slot still has value → STOP (don't clear tag, qty, radio)
      // if (stillFilled) {
            // updatePopupRadioStates();
        // return;
      // }
  
      // --- 3. Now safe to clear card values because ALL slots are empty ---
      const productCard = document.querySelectorAll(`.product-card[data-handle="${metaHandle}"]`);
      productCard.forEach(card => {        
        if (card) {  
          const occupied_slot = card.querySelector("[occcupied_slot]")?.getAttribute("occcupied_slot") || 1;          
          const qtyInput = card.querySelector(".quantity_product_card");
          // if (qtyInput) qtyInput.value = parseInt(occupied_slot);
          // if (qtyInput) qtyInput.value = qtyInput.value - 1 ;
          if (qtyInput && qtyInput.value > 0) qtyInput.value = (qtyInput.value - 1) ;
            qtyInput.closest('.card-information').classList.remove('limet_over'); 
            checkQtyButtonState(this); 
            const radio = card?.querySelector(".variant-radio:checked");
          if (radio) radio.checked = false;
          const checkbox = card?.querySelector(".variant-checkbox:checked");
          if(checkbox) checkbox.checked = true;
          const label = card?.querySelector(".selected_product_tag");
          if(qtyInput.value <= 0 ) if (label) label.innerHTML = "";
          // isalready_selected_any_product(radio);
        }
      });      
    } 
    updatePopupRadioStates();
  }
  
  checkQtyButtonState(tag, currentRadio, totalQty) {      
    const is_multi_collaps = currentRadio?.closest(".multi_acc_seleceted");
    if(!is_multi_collaps){
      this.count_fill_qty = this.slotInputs.filter(i => i.checked).length;
      const allFilled = this.slotInputs.every(i => i.checked);
      const acc_design = this.querySelector(".is_accordion_design");      
      const parent = currentRadio?.closest(".product-card");
      const selecetd_tag = parent?.querySelector(".card__inner .selected_product_tag");

      const labelText = currentRadio?.dataset.tagText || "";    
      const select_btn = currentRadio?.closest(".product-grid")?.querySelectorAll(".variant-checkbox");    

      if(!allFilled) document.body.classList.remove("slot_full_open_popup");
      const is_slot_fill = document.body.classList.contains("slot_full_open_popup");
        
      if(is_slot_fill){
        select_btn?.forEach(btn => {
          const wrapper = btn.closest(".select_product");
          const parent = btn.closest(".product-card");
          const selecetd_tag = parent.querySelector(".card__inner .selected_product_tag");
          const check_all_tag = selecetd_tag.textContent.trim()|| null;                         
          if(check_all_tag){
            
               // popup up open
            const mainDiv = currentRadio.closest(".product-card-wrapper");
            if (!mainDiv) return;    
            // Check if .thirdMeta exists
              const popupElement = mainDiv.querySelector('.popup_data_info');               
              // const popupElement = mainDiv.querySelector(hasThirdMeta ? '.popup_data_info');          
              if (popupElement) {
                mainDiv.querySelector(".card_popup_content")?.classList.add("popup-active");
                popupElement.style.display = 'block';
                document.body.classList.add('popup-active');
              }  
              this.popDesc = popupElement.querySelector(".total_capacity");
              if(this.popDesc) this.popDesc.innerHTML = this.count_fill_qty;

              const totalQtyinp = popupElement.querySelector(".current_capacity");
              if(totalQtyinp) totalQtyinp.innerHTML = totalQty;
          }
        });
      } else{        
        const selecetd_tag = parent.querySelector(".card__inner .selected_product_tag");
        currentRadio.checked = false;
        selecetd_tag.innerHTML = labelText;
        if(allFilled) document.body.classList.add("slot_full_open_popup");
      }
  
      if (!tag) {       
        const sixth_step = document.querySelector(".show_selecetd_acc_product");
        const six_id = sixth_step?.querySelectorAll("metawise-variant-selector[data-product-var-id]");
        const currentVarId = currentRadio.dataset.varId;
        // check if any var-id matches then remove that div
        Array.from(six_id).forEach(el => {
          if (el.dataset.productVarId === currentVarId) el.remove();         
        });
      }  
      
      // plus button functionlity
      if(acc_design) return;
        const plusQty = document.querySelectorAll(".selected_product_data.active .plus_qty_product");
        // 
        if (allFilled) {                           
          plusQty.forEach(btn => {        
            btn.classList.add("disabled");
            btn.style.pointerEvents = "none";
            const parent = btn.closest("quantity-input");
            if (parent) parent.querySelector(".quantity_product_card").value = 1;
            // 
          });    
        } else {      
          plusQty.forEach(btn => {                                 
            // 
            btn.classList.remove("disabled");
            btn.style.pointerEvents = "initial";
          });
        }
    }

  }

  checkInpNoProductDisable() {    
    const emptyInputs = this.slotInputs.filter(slot => {
      const input = slot.querySelector(".meta-slot-input");
      return !input || input.value.trim() === "";
    });
  
    // flag
    this.hasEmptyValue = emptyInputs.length > 0;  
    // disable pointer events
    emptyInputs.forEach(slot => {
      const input = slot.querySelector(".meta-slot-input");
      if (input) {
        input.style.pointerEvents = "none";
        input.style.opacity = "0.5"; // optional visual feedback
        input.style.cursor = "not-allowed";
      }  
    });
  }
  


  setupSlotInputChange() {
    this.slotInputs.forEach(input => {
      if (input.dataset.changeAdded === "true") return;
      input.dataset.changeAdded = "true";
  
      input.addEventListener("change", () => {
        if (!input.checked) {
          
          this.clearSlot(input);
          this.checkQtyButtonState(true, input);
        }       
      });
    });
  }

  extraQtyChangeSku(){
    this.querySelectorAll('.first_popcard_close')?.forEach(skuBtn => {
      skuBtn.addEventListener("click", async (event) => {
        // Prevent duplicate event listeners
        if (skuBtn.dataset.listenerAdded === "true") return;
        skuBtn.dataset.listenerAdded = "true";        
        // this.parent = skuBtn.closest(".product-card");          
        const parent = skuBtn.closest(".meta-wise-selected-variant");        
        const main_product = parent.querySelector(".selected_product_flex_meta");                
        const selectedVariantHandle = main_product.getAttribute("pre-selecetd-handle-pop");  
        const selecetdSkuStep = main_product.getAttribute('pre-selecetd-sku-pop') || null;        
        const mainDiv = skuBtn.closest(".product-card-wrapper");  
                
          if (selectedVariantHandle && selecetdSkuStep) {  
            
            const selected_product_function = await selecetd_product_show(selectedVariantHandle, skuBtn, selecetdSkuStep);                  
            const popupContent =  mainDiv.querySelector(".card_popup_content");
            if(popupContent) popupContent.classList.remove('popup-active');          
            document.body.classList.remove('popup-active');
            document.body.classList.add("is_rerender_step_fourth")
            const card_content = document.querySelector(".main-tab-products-content");
            const card_handle = card_content.querySelectorAll(".data-handle");
            const slotData = JSON.parse(localStorage.getItem("slotproduct") || "[]");          
            const slotHandles = new Set(slotData.map(p => p.handle));                            
              setTimeout(() => {           
                document.querySelectorAll(".main-tab-products-content .product-card-wrapper").forEach(card => {                  
                    if (!slotHandles.has(card.dataset.handle)) return;
                    card.querySelector(".variant-checkbox.cust_btn_select")?.click();
                });
              }, 1000);
          }else{
            
            const mainDiv = skuBtn.closest(".product-card-wrapper");    
            // Hide both possible popups
            const bothPopup = mainDiv?.querySelector(".popup_data, .popup_data_info");
              if(bothPopup) bothPopup.style.display = 'none';
            
            const popupContent =  mainDiv.querySelector(".card_popup_content");
              if(popupContent) popupContent.classList.remove('popup-active');
            
            document.body.classList.remove('popup-active');
          }       
      });
    });
  }

  popup_show_close(){
    this.querySelectorAll('.close_btn, .second_popcard_close, .third_popcard_close')?.forEach(closeBtn => {
      closeBtn.addEventListener("click", (event) => {
        event.stopPropagation();        
          const mainDiv = closeBtn.closest(".product-card-wrapper");
    
          // Hide both possible popups
          const bothPopup = mainDiv?.querySelector(".popup_data, .popup_data_info");
             if(bothPopup) bothPopup.style.display = 'none';
          
          const popupContent =  mainDiv.querySelector(".card_popup_content");
              if(popupContent) popupContent.classList.remove('popup-active');
          
          document.body.classList.remove('popup-active');
      });
    });
  }  

  setupRadioListeners() {
    const radios = this.querySelectorAll(".product-card .variant-radio");
    if (!radios.length) return;

    radios.forEach(radio => {
    if (radio.dataset.listenerAdded === "true") return;
    radio.dataset.listenerAdded = "true";

    radio.addEventListener("change", () => {      
      const variantId = radio.value;
      const card = radio.closest(".grid__item");
      const handle = radio.dataset.varHandle;
      const parent_section = radio.closest(".selected_product_data");      
      // const frame_capa = parseInt(parent_section?.querySelector("[data-frame-capacity]").getAttribute("data-frame-capacity"));   
      // 
      const productTitle = radio.dataset.productTitle;
      const parent = radio.closest(".product-card");
      const selecetd_tag = parent.querySelector(".card__inner .selected_product_tag");
      const labelText = radio.dataset.tagText || "";    
      const matchedSlot = this.getSlotByHandle(handle);                        
      this.is_multi_acc_show = radio.classList;
      this.input_wrap = radio.closest(".select_product");
      const totalQty = Array.from(radios)
      .filter(input => !input.value.includes(labelText))
      .reduce((sum, input) => {
        const card = input.closest(".product-card");
        const qty = parseInt(
          card?.querySelector(".quantity_product_card")?.value || "1",
          10
        );
        return sum + qty;
      }, 0);

      if (selecetd_tag.textContent.trim() === "" ) {         
        // is_selected_any_product(radio);
        const mainCard = radio.closest(".product-card");

        const main_input = mainCard.querySelector(".quantity_product_card") || null;
        if(!main_input) return;

        const occcupied_slot = main_input.getAttribute('occcupied_slot') || 1;
        const qty = parseInt(main_input.value || "1");

         const image_parent = parent_section?.querySelector(".selecetd_product_image");

        if(occcupied_slot ==1){
        
        for (let i = 0; i < qty; i++) {
          const emptySlot = this.getNextEmptySlot();          
          if (!emptySlot) break;
          console.log("fill_slot_function_called")
          this.fillSlot(i,image_parent, radio, emptySlot, variantId, handle, productTitle);
        }  
      }else{
          const emptySlot = this.getNextEmptySlot();    
         if (!emptySlot) return; 
         this.checkQtyButtonState(true, radio, totalQty);
         fillSlot_occcupied_slot(image_parent, radio, occcupied_slot, variantId, handle, productTitle,qty,this);

      }  

        this.handleSelection(radio);
        radio.checked = false;
        selecetd_tag.innerHTML = labelText;
        this.checkQtyButtonState(true, radio, totalQty);
        let input_val = card.querySelector(".quantity__input").value || 1;  
        if(input_val && !card.classList.contains("active")){
          input_val = parseInt(input_val) + 1
          const qty_inp = card.querySelector(".quantity__input"); 
            if(qty_inp)qty_inp.value = input_val;
        }   
        const step_no = get_the_step_no(input);

        renderSelectedProducts(handle, radio.name, input_val, step_no);
        if(this.is_multi_acc_show?.contains(".is_multi_selected_acc"))
          {
          
          multiProductsAccSelected(handle, radio.name);
        }        
      } else {           
      }
      const allBlank = this.slotInputs.every(input => !input.checked);      
        if (allBlank) {
          // isalready_selected_any_product(radio); // run only on first selection
        }
           
    });    
    });
  }
  
  removePriductDeselected(handle){
    const products = document.querySelectorAll(".multi_acc_products");
    products.forEach(product => {
      const multi_pro_handle = product.dataset.handle;  
      if (multi_pro_handle === handle) {
        // product ne closest metawise-variant-selector (bahar no parent)
        const variantWrapper = product.closest(".metawise-variant-selector");        
        if (variantWrapper) {
          variantWrapper.remove();
        }
      }
    });
  }
}

if (!customElements.get("metawise-variant-selector")) {
  customElements.define("metawise-variant-selector", MetaVariantSelector);
}
